import type { ProgramTheme } from '../api/useProgramThemes';

type ThemeStatus = 'Default' | 'Active' | 'Archived';

const statusClass: Record<ThemeStatus, string> = {
  Default: 'bg-green-100 text-green-700',
  Active: 'bg-blue-100 text-blue-700',
  Archived: 'bg-gray-100 text-gray-600',
};

export const themeStatus = (theme: Pick<ProgramTheme, 'is_default' | 'archived'>): ThemeStatus =>
  theme.archived ? 'Archived' : theme.is_default ? 'Default' : 'Active';

export const ThemeStatusBadge = ({ theme }: { theme: Pick<ProgramTheme, 'is_default' | 'archived'> }) => {
  const status = themeStatus(theme);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusClass[status]}`}>
      {status}
    </span>
  );
};
